/** Vite inlines these at build time; missing values fall back to the dev proxy. */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
export const IS_DEV = import.meta.env.DEV;

/**
 * Browser key for the Google Maps JavaScript API, used by the pharmacy
 * coverage map. Empty is a supported state: the map says what is missing
 * instead of rendering a grey box, so a panel without a key is still usable
 * for everything that is not drawing a delivery boundary.
 *
 * This key ships to the browser and cannot be secret. Restrict it by HTTP
 * referrer and to the Maps JavaScript API in the Google Cloud console — that
 * restriction, not secrecy, is what stops someone else spending your quota.
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';
